<div ngModelGroup="comboEstadoCivil-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboEstadoCivil
                       nome="estadoCivil-{{data}}"
                       [itens]="dados"
                       itemDescricao="tipo"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Estado civil"
                       label="Estado Civil"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
